const PHRASE = "Antes de crear contenido, hay que saber mirar";

export default function Marquee() {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden bg-mirian-wine py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {items.map((_, i) => (
              <span
                key={i}
                className="mx-8 font-serif text-xl italic text-mirian-cream md:text-2xl"
              >
                {PHRASE}
                <span className="ml-16 not-italic text-mirian-cream/40">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
